import React from 'react';
import Loadable from 'react-loadable';
import {Helmet} from "react-helmet";
import { auth } from '../firebase/index.js';


import {
  BrowserRouter as Router,
  Route,
} from 'react-router-dom';

import Header from './header/index.js';
//import Spend from './spend/index.js';
//import Progress from './progress/index.js';
/*import Paper from './paper/index.js';
import Powerball from './powerball/index.js';
import Speed from './speed/index.js';
import Logos from './logos-from-memory/index.js';*/
import './template.css';
import './bootstrap.min.css';

const Home = Loadable({
  loader: () => import('./Home.js'),
  loading: "loading",
});

const Spend = Loadable({
  loader: () => import('./spend/index.js'),
  loading: "loading",
});

const Paper = Loadable({
  loader: () => import('./paper/index.js'),
  loading: "loading",
});

const Powerball = Loadable({
  loader: () => import('./powerball/index.js'),
  loading: "loading",
});

const Speed = Loadable({
  loader: () => import('./speed/index.js'),
  loading: "loading",
});

const Logos = Loadable({
  loader: () => import('./logos-from-memory/index.js'),
  loading: "loading",
});

const LifeChecklist = Loadable({
  loader: () => import('./life-checklist/index.js'),
  loading: "loading",
});

const DrawIsland = Loadable({
  loader: () => import('./draw-your-island/index.js'),
  loading: "loading",
});

const Progress = Loadable({
  loader: () => import('./progress/index.js'),
  loading: "loading",
});

const BabyMap = Loadable({
  loader: () => import('./baby-map/index.js'),
  loading: "loading",
});

const WikiFiles = Loadable({
  loader: () => import('./wiki-files/index.js'),
  loading: "loading",
});

const HurricaneMap = Loadable({
  loader: () => import('./hurricane-map/index.js'),
  loading: "loading",
});

const RejectedCaptchas = Loadable({
  loader: () => import('./rejected-captchas/index.js'),
  loading: "loading",
});

const Footer = Loadable({
  loader: () => import('./footer.js'),
  loading: "loading",
});

class App extends React.Component {

  constructor(props){
    super(props);
    this.state = {authUser: null, fullUser: null, loaded: false};
  }

  componentDidMount(){
    auth.onAuthStateChanged(authUser => {
      this.setState({authUser: authUser, loaded: true});
      if(authUser){
        auth.getUserByUid(authUser.uid, function(fullUser){
          this.setState({fullUser: fullUser});
          console.log(fullUser);
        }.bind(this));
      }
    });
  }

  render(){
    return <Router>
      <div>
        <Route
          exact path={"/"}
          component={() => <Home />}
        />
        <Route
          exact path={"/spend"}
          component={() =>
            <div>
              <Helmet>
                <link rel="stylesheet" type="text/css" href="/spend/index.css"/>
              </Helmet>
              <Header/>
              <Spend />
              <Footer title="Spend Bill Gate's Money" url="http://neal.fun/spend/" shareText="Spend Bill Gate's Money" maxWidth="960"/>
            </div>}
        />
        <Route
          exact path={"/paper"}
          component={() => <div><Header/><Paper /><Footer title="Paper" url="http://neal.fun/paper/" shareText="What happens if you keep folding a piece of paper?"/></div>}
        />
        <Route
          exact path={"/powerball"}
          component={() => <div><Header/><Powerball/><Footer title="Powerball" url="http://neal.fun/powerball/" shareText="Win the Powerball" maxWidth="940" marginLeft="15"/></div>}
        />
        <Route
          exact path={"/speed"}
          component={() => <div><Header/><Speed /><Footer title="How Fast Are You Moving?" url="http://neal.fun/speed/" shareText="Speed"/></div>}
        />
        <Route
          exact path={"/logos-from-memory"}
          component={() => <div><Header/><Logos /><Footer title="Draw Logos From Memory" url="http://neal.fun/logos-from-memory/" shareText="Try to draw famous logos from memory" /></div>}
        />
        <Route
          exact path={"/draw-your-island"}
          component={() => <div><Header/><DrawIsland /><Footer title="Draw Your Island" url="http://neal.fun/draw-your-island/" shareText="Draw Your Island" maxWidth="816" marginLeft="8" /></div>}
        />
        <Route
          exact path={"/progress"}
          component={() => <div><Header/><Progress /></div>}
        />
        <Route
          exact path={"/baby-map"}
          component={() => <div><Header/><BabyMap /></div>}
        />
        <Route
          exact path={"/wiki-files"}
          component={() => <div><Header/><WikiFiles /><Footer title="Wiki Files" url="http://neal.fun/wiki-files/" shareText="Wikipedia as a file system"/></div>}
        />
        <Route
          exact path={"/hurricane-map"}
          component={() => <HurricaneMap />}
        />
        <Route
          exact path={"/rejected-captchas"}
          component={() => <RejectedCaptchas />}
        />
        <Route path="/life-checklist/:username?" render={(props) => {
          return <div>
                <Header loaded={this.state.loaded} fullUser={this.state.fullUser}/>
                <LifeChecklist loaded={this.state.loaded} authUser={this.state.authUser} username={props ? props.match.params.username : ""}/>
                <Footer title="Life Checklist" url="http://neal.fun/life-checklist/" shareText="How many items have you checked off?" maxWidth="1060" marginLeft="5"/>
            </div>
          }}
        />
      </div>
    </Router>
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/components/App.js